// Sticky header: marks the header as scrolled (shadow). With data-autohide it also tucks away while scrolling down,
// bringing it back on any upward scroll. Focus inside the header keeps it visible.
class StickyHeader extends HTMLElement {
  #controller = null;
  #lastY = 0;
  #ticking = false;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.#lastY = window.scrollY;
    this.#update();
    window.addEventListener('scroll', () => this.#onScroll(), { passive: true, signal });
    this.addEventListener('focusin', () => this.removeAttribute('data-hidden'), { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #onScroll() {
    if (this.#ticking) return;
    this.#ticking = true;
    requestAnimationFrame(() => {
      this.#update();
      this.#ticking = false;
    });
  }

  #update() {
    const y = Math.max(window.scrollY, 0);
    const threshold = this.offsetHeight || 80;
    this.toggleAttribute('data-scrolled', y > 8);
    const goingDown = y > this.#lastY + 4;
    const goingUp = y < this.#lastY - 4;
    // Always visible: auto-hide only when the header opts in with data-autohide.
    if (this.hasAttribute('data-autohide') && goingDown && y > threshold * 2 && !this.matches(':focus-within')) {
      this.setAttribute('data-hidden', '');
    } else if (goingUp || y <= threshold) {
      this.removeAttribute('data-hidden');
    }
    if (goingDown || goingUp) this.#lastY = y;
  }
}

if (!customElements.get('s-sticky-header')) {
  customElements.define('s-sticky-header', StickyHeader);
}
